'use client'

import React from 'react'
import { RadioGroup as RadioGroupPrimitive } from 'radix-ui'
import { cn } from '@/utils'

export type RadioGroupRootProps = React.ComponentPropsWithRef<
  typeof RadioGroupPrimitive.Root
>

const RadioGroupRoot = ({ className, ...props }: RadioGroupRootProps) => (
  <RadioGroupPrimitive.Root className={cn(className)} {...props} />
)
RadioGroupRoot.displayName = RadioGroupPrimitive.Root.displayName

export type RadioGroupItemProps = React.ComponentPropsWithRef<
  typeof RadioGroupPrimitive.Item
>

const RadioGroupItem = ({ className, ...props }: RadioGroupItemProps) => (
  <RadioGroupPrimitive.Item
    className={cn(
      'group peer relative size-5 shrink-0 cursor-pointer rounded-full border-2 border-black bg-white',
      'disabled:cursor-not-allowed disabled:border-gray-400',
      'data-[state=checked]:border-support-200 data-[state=checked]:bg-support-200',
      'data-[state=checked]:disabled:border-gray-300 data-[state=checked]:disabled:bg-gray-300',
      className,
    )}
    {...props}
  />
)
RadioGroupItem.displayName = RadioGroupPrimitive.Item.displayName

export type RadioGroupIndicatorProps = React.ComponentPropsWithRef<
  typeof RadioGroupPrimitive.Indicator
>

const RadioGroupIndicator = ({
  className,
  children,
  ...props
}: RadioGroupIndicatorProps) => (
  <RadioGroupPrimitive.Indicator
    className={cn('flex size-full items-center justify-center', className)}
    {...props}
  >
    {children ?? <span className="size-2 rounded-full bg-white" />}
  </RadioGroupPrimitive.Indicator>
)
RadioGroupIndicator.displayName = RadioGroupPrimitive.Indicator.displayName

export type RadioGroupLabelProps = React.ComponentPropsWithRef<'label'>

const RadioGroupLabel = ({ className, ...props }: RadioGroupLabelProps) => (
  <label
    className={cn(
      'text-body-2 text-gray-500 peer-disabled:text-gray-300',
      className,
    )}
    {...props}
  />
)
RadioGroupLabel.displayName = 'RadioGroupLabel'

export { RadioGroupRoot, RadioGroupItem, RadioGroupIndicator, RadioGroupLabel }
